"use client";

import { Icon } from "@/components/ui/icon";
import { cn } from "@/lib/utils";

export type DialogStepperStep = {
  key: string;
  label: string;
};

export type DialogStepperProps = {
  steps: DialogStepperStep[];
  currentStep: string;
};

export function DialogStepper({ steps, currentStep }: DialogStepperProps) {
  const currentIndex = steps.findIndex((s) => s.key === currentStep);

  return (
    <div className="flex items-center justify-between gap-1 px-1">
      {steps.map((step, index) => {
        const isCompleted = index < currentIndex;
        const isActive = index === currentIndex;

        return (
          <div key={step.key} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center gap-1">
              <div
                className={cn(
                  "flex items-center justify-center size-6 rounded-full text-xs font-semibold transition-colors shrink-0",
                  isCompleted &&
                    "bg-primary text-primary-foreground",
                  isActive &&
                    "border-2 border-primary text-primary",
                  !isCompleted &&
                    !isActive &&
                    "border border-muted-foreground/30 text-muted-foreground/50",
                )}
              >
                {isCompleted ? (
                  <Icon icon="CheckSolid" className="size-3" />
                ) : (
                  index + 1
                )}
              </div>
              <span
                className={cn(
                  "text-[10px] leading-tight whitespace-nowrap",
                  isActive && "font-semibold text-foreground",
                  isCompleted && "text-muted-foreground",
                  !isCompleted && !isActive && "text-muted-foreground/50",
                )}
              >
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <div
                className={cn(
                  "h-px flex-1 mx-1.5 mb-4 transition-colors",
                  index < currentIndex
                    ? "bg-primary"
                    : "bg-muted-foreground/20",
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

DialogStepper.displayName = "DialogStepper";
